var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#11AB1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.84 19.12C30.8716 17.4717 31.6029 15.6536 32 13.75C32.75 17.5 35 21.1 38 23.5C41 25.9 42.5 28.75 42.5 31.75C42.5086 33.8234 41.9013 35.8527 40.7552 37.5806C39.6091 39.3085 37.9757 40.6572 36.0622 41.4557C34.1487 42.2542 32.0411 42.4666 30.0068 42.0659C27.9724 41.6652 26.1028 40.6695 24.635 39.205M21.5 33.67C24.8 33.67 27.5 30.925 27.5 27.595C27.5 25.855 26.645 24.205 24.935 22.81C23.225 21.415 21.935 19.345 21.5 17.17C21.065 19.345 19.79 21.43 18.065 22.81C16.34 24.19 15.5 25.87 15.5 27.595C15.5 30.925 18.2 33.67 21.5 33.67Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelIcon);
export default __webpack_public_path__ + "static/media/fuel_icon.995c3d167b2eea65be61cf365e938220.svg";
export { ForwardRef as ReactComponent };